import { NetworkProvider } from "./modules/network";
import { useAuth } from "./modules/auth";
import { useSettingsLongPolling } from "./modules/control";
import { ChatButton, Chat } from "./modules/chat";
import {
  useResetChatNotifications,
  useShowMessageCount,
} from "./packages/hooks";
import type { Config } from "./modules/control";
import type { ChatChildren } from "./modules/chat";

type Props = {
  dataTestId?: string;
  className: string;
  children: ChatChildren;
};

export const Application = ({
  dataTestId = "chat-icon-container",
  className,
  children,
}: Props) => {
  useAuth();
  useSettingsLongPolling();
  useResetChatNotifications();
  useShowMessageCount();

  return (
    <NetworkProvider>
      <ChatButton dataTestId={dataTestId} className={className}>
        {children}
      </ChatButton>
      <Chat />
    </NetworkProvider>
  );
};

export type { Config };
